import React from 'react';
import { Smartphone } from 'lucide-react';
import { useInstall } from '../context/InstallContext';

/**
 * Subtle permanent footer link. Only rendered when:
 *   - browser is capable of PWA install (canInstall)
 *   - app is not already installed
 *
 * Not gated by the 7-day cooldown: users who dismissed the top banner should
 * still have a path to install whenever they want.
 */
const InstallFooterLink = () => {
  const { canInstall, promptInstall } = useInstall();
  if (!canInstall) return null;

  return (
    <button
      type="button"
      onClick={() => promptInstall()}
      style={styles.link}
      data-testid="pwa-install-footer-link"
    >
      <Smartphone size={13} style={{ marginRight: '0.35rem' }} />
      Installeer de CasaOthers-app
    </button>
  );
};

const styles = {
  link: {
    display: 'inline-flex', alignItems: 'center',
    background: 'transparent', border: 'none',
    color: '#C5A059', textDecoration: 'none',
    padding: '0.25rem 0', margin: 0,
    fontFamily: "'Manrope', sans-serif",
    fontSize: '0.82rem', fontWeight: 500,
    cursor: 'pointer', letterSpacing: '0.02em',
  },
};

export default InstallFooterLink;
